var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateFrom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.5,
    viewBox: "0 0 15 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7588",
    "data-name": "Group 7588",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2839",
    "data-name": "Rectangle 2839",
    width: 14,
    height: 12,
    transform: "translate(0.5 2)",
    fill: "var(--mainColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_430",
    "data-name": "Line 430",
    y2: 3.506,
    transform: "translate(10.421)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_431",
    "data-name": "Line 431",
    y2: 3.506,
    transform: "translate(4.251)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2840",
    "data-name": "Rectangle 2840",
    width: 2.103,
    height: 2.103,
    transform: "translate(8.318 5.959)",
    fill: "var(--bgColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2841",
    "data-name": "Rectangle 2841",
    width: 2.103,
    height: 2.103,
    transform: "translate(4.251 5.959)",
    fill: "var(--bgColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2842",
    "data-name": "Rectangle 2842",
    width: 2.103,
    height: 2.103,
    transform: "translate(8.318 9.816)",
    fill: "var(--bgColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2843",
    "data-name": "Rectangle 2843",
    width: 2.103,
    height: 2.103,
    transform: "translate(4.251 9.816)",
    fill: "var(--bgColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateFrom);
export default __webpack_public_path__ + "static/media/date_from.d54beafd8233e3185693998f200025df.svg";
export { ForwardRef as ReactComponent };